import { render, staticRenderFns } from "./table-sender.vue?vue&type=template&id=6aa1eb8e&"
import script from "./table-sender.vue?vue&type=script&lang=js&"
export * from "./table-sender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports